export const SMALL_GRID = 16;

export const createGrid = (size) =>
  Array(size)
    .fill([])
    .map(() => Array(size).fill(0));
